/* global axios */
import ApiClient from './ApiClient';

class FlowsAPI extends ApiClient {
  constructor() {
    super('flows', { accountScoped: true });
  }

  getFlows() {
    return axios.get(this.url);
  }

  getFlow(flowId) {
    return axios.get(`${this.url}/${flowId}`);
  }

  createFlow(payload) {
    return axios.post(this.url, { flow: payload });
  }

  updateFlow(flowId, payload) {
    return axios.patch(`${this.url}/${flowId}`, { flow: payload });
  }

  publishFlow(flowId) {
    return axios.post(`${this.url}/${flowId}/publish`);
  }

  pauseFlow(flowId) {
    return axios.post(`${this.url}/${flowId}/pause`);
  }

  resumeFlow(flowId) {
    return axios.post(`${this.url}/${flowId}/resume`);
  }

  deleteFlow(flowId) {
    return axios.delete(`${this.url}/${flowId}`);
  }
}

export default new FlowsAPI();
